import type { QueryKey } from '@tanstack/react-query';

import type { SearchPortal } from './types';

/**
 * Quick Find cache keys (CONTRACT §4): the portal, WHO is searching and the
 * term — `['search', portal, identity, q]`.
 *
 * The identity is the signed-in person and the organisation or supplier they
 * act for, so one person's results can never answer another's search, even
 * for the instant before a cache is cleared. The operator's keys start with
 * `'platform'`, so the operator MFA gate and the operator sign-out (which drop
 * everything under `'platform'`) take them too. The tenant MFA gate and
 * sign-outs that clear the cache take the rest.
 */
export function quickFindPrefix(portal: SearchPortal): QueryKey {
  return portal === 'platform' ? ['platform', 'search'] : ['search', portal];
}

export function quickFindKey(portal: SearchPortal, identity: string, q: string): QueryKey {
  return [...quickFindPrefix(portal), identity, q];
}

/** Opaque identity parts joined; an absent part stays visible as `-`. */
export function identityKey(parts: readonly (string | number | null | undefined)[]): string {
  return parts
    .map((part) => (part === null || part === undefined || part === '' ? '-' : String(part)))
    .join(':');
}
